import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "filterLine"
};
const _hoisted_2 = {
  class: "filterFieldsFullWidth"
};
const _hoisted_3 = {
  class: "filterField"
};
const _hoisted_4 = {
  class: "titleFilter"
};
const _hoisted_5 = {
  class: "filterField"
};
const _hoisted_6 = {
  class: "titleFilter"
};
const _hoisted_7 = {
  class: "filterField"
};
const _hoisted_8 = {
  class: "titleFilter"
};
const _hoisted_9 = {
  class: "filterExpand"
};
const _hoisted_10 = {
  class: "filterLine"
};
const _hoisted_11 = {
  class: "filterFieldsFullWidth"
};
const _hoisted_12 = {
  class: "filterField"
};
const _hoisted_13 = {
  class: "titleFilter"
};
const _hoisted_14 = {
  class: "filterField"
};
const _hoisted_15 = {
  class: "titleFilter"
};
const _hoisted_16 = {
  key: 0,
  class: "filtersRecap"
};
const _hoisted_17 = {
  class: "filterTags"
};
const _hoisted_18 = {
  class: "labelNumberUsers"
};
const _hoisted_19 = {
  id: "TableUsers"
};
const _hoisted_20 = {
  class: "tableHeader"
};
const _hoisted_21 = {
  class: "tableHeader"
};
const _hoisted_22 = {
  key: 0
};
const _hoisted_23 = {
  key: 1
};
const _hoisted_24 = {
  class: "tableHeader"
};
const _hoisted_25 = {
  class: "datesCell"
};
const _hoisted_26 = {
  class: "tableHeader"
};
const _hoisted_27 = {
  class: "datesCell"
};
const _hoisted_28 = {
  class: "tableHeader"
};
const _hoisted_29 = {
  key: 1
};
const _hoisted_30 = ["onClick"];
const _hoisted_31 = {
  key: 0,
  class: "loadingContainer"
};
const _hoisted_32 = {
  class: "loadingContainer"
};
const _hoisted_33 = {
  class: "multiselectActions"
};
const _hoisted_34 = {
  class: "multiselectLeftPart"
};
const _hoisted_35 = {
  class: "popupRow"
};
const _hoisted_36 = {
  class: "messagePopup"
};
const _hoisted_37 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_w_input = _resolveComponent("w-input");
  const _component_w_select_advanced = _resolveComponent("w-select-advanced");
  const _component_w_date_picker_range = _resolveComponent("w-date-picker-range");
  const _component_el_affix = _resolveComponent("el-affix");
  const _component_w_tag = _resolveComponent("w-tag");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_user_cell = _resolveComponent("user-cell");
  const _component_w_tool_tip = _resolveComponent("w-tool-tip");
  const _component_loader = _resolveComponent("loader");
  const _component_el_table = _resolveComponent("el-table");
  const _component_user_details = _resolveComponent("user-details");
  const _component_side_panel = _resolveComponent("side-panel");
  const _component_infinite_loading = _resolveComponent("infinite-loading");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_w_dialog = _resolveComponent("w-dialog");
  const _component_batch_update_user = _resolveComponent("batch-update-user");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _directive_click_outside = _resolveDirective("click-outside");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tableLayout", {
      loaded: _ctx.isLoaded
    }])
  }, [_createVNode(_component_el_affix, {
    offset: 80,
    onChange: _ctx.onFixChange
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(["filterBar", _ctx.fixeBar ? 'fix' : ''])
    }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('admin.dashboard.users.search.title.name')), 1), _createVNode(_component_w_input, {
      modelValue: _ctx.filterByName,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.filterByName = $event),
      placeholder: _ctx.$t('admin.dashboard.users.search.placeholder.name'),
      clearable: "",
      onInput: _cache[1] || (_cache[1] = $event => _ctx.debouncedSearch())
    }, {
      prefix: _withCtx(() => [_createVNode(_component_icon, {
        icon: "magnify",
        class: "iconMagnify"
      })]),
      _: 1
    }, 8, ["modelValue", "placeholder"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('admin.dashboard.users.search.title.group')), 1), _createVNode(_component_w_select_advanced, {
      "value-key": "id",
      options: _ctx.groups,
      placeholder: _ctx.$t('admin.dashboard.users.search.placeholder.group'),
      onChange: _ctx.changeSelectedGroups,
      value: _ctx.selectedGroups,
      multiple: true,
      "collapse-tags": true,
      filterable: true,
      "option-all": true,
      "label-key": "name"
    }, null, 8, ["options", "placeholder", "onChange", "value"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('admin.dashboard.users.search.title.role')), 1), _createVNode(_component_w_select_advanced, {
      "value-key": "id",
      options: _ctx.roles,
      placeholder: _ctx.$t('admin.dashboard.users.search.placeholder.role'),
      onChange: _ctx.changeSelectedRoles,
      value: _ctx.selectedRoles,
      multiple: true,
      "collapse-tags": true,
      "option-all": true,
      "label-key": "name"
    }, null, 8, ["options", "placeholder", "onChange", "value"])])]), _createElementVNode("div", _hoisted_9, [_cache[7] || (_cache[7] = _createElementVNode("div", {
      class: "titleFilter"
    }, " ", -1)), _withDirectives(_createVNode(_component_icon, {
      icon: "filter-variant-plus",
      class: "iconExpandFilterUser",
      onClick: _ctx.changeFilterExpandedState
    }, null, 8, ["onClick"]), [[_vShow, !_ctx.filterExpanded]]), _withDirectives(_createVNode(_component_icon, {
      icon: "filter-variant-minus",
      class: "iconExpandFilterUser",
      onClick: _ctx.changeFilterExpandedState
    }, null, 8, ["onClick"]), [[_vShow, _ctx.filterExpanded]])])]), _createVNode(_Transition, {
      name: "expand"
    }, {
      default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('admin.dashboard.users.table.createdAt')), 1), _createVNode(_component_w_date_picker_range, {
        "calendar-range": _ctx.calendarRangeCreated,
        placement: "bottom-start",
        onChangeCalendarRange: _ctx.changeCalendarRangeCreated,
        separator: "-"
      }, null, 8, ["calendar-range", "onChangeCalendarRange"])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('admin.dashboard.users.table.lastActive')), 1), _createVNode(_component_w_date_picker_range, {
        "calendar-range": _ctx.calendarRangeLastActive,
        placement: "bottom-start",
        onChangeCalendarRange: _ctx.changeCalendarRangeLastActive,
        separator: "-"
      }, null, 8, ["calendar-range", "onChangeCalendarRange"])]), _cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "filterField"
      }, null, -1))]), _cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "filterExpand"
      }, null, -1))], 512), [[_vShow, _ctx.filterExpanded]])]),
      _: 1
    })], 2)]),
    _: 1
  }, 8, ["onChange"]), _ctx.filterByName || _ctx.selectedGroups.length > 0 || _ctx.selectedRoles.length > 0 || _ctx.calendarRangeLastActive && _ctx.calendarRangeLastActive.length >= 1 && _ctx.calendarRangeLastActive[0] || _ctx.calendarRangeCreated && _ctx.calendarRangeCreated.length >= 1 && _ctx.calendarRangeCreated[0] ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_ctx.filterByName ? (_openBlock(), _createBlock(_component_w_tag, {
    key: 0,
    "text-tag": _ctx.filterByName,
    round: "",
    closable: true,
    onRemoveTag: _ctx.clearFilterByName
  }, null, 8, ["text-tag", "onRemoveTag"])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedGroups, group => {
    return _openBlock(), _createBlock(_component_w_tag, {
      key: group,
      "text-tag": _ctx.$t('admin.dashboard.users.table.groups') + ': ' + _ctx.groupName(group),
      round: "",
      closable: true,
      onRemoveTag: $event => _ctx.clearFilterByGroup(group)
    }, null, 8, ["text-tag", "onRemoveTag"]);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedRoles, role => {
    return _openBlock(), _createBlock(_component_w_tag, {
      key: role,
      "text-tag": _ctx.$t('admin.dashboard.users.table.roles') + ': ' + _ctx.roleName(role),
      round: "",
      closable: true,
      onRemoveTag: $event => _ctx.clearFilterByRole(role)
    }, null, 8, ["text-tag", "onRemoveTag"]);
  }), 128)), _ctx.calendarRangeLastActive && _ctx.calendarRangeLastActive.length >= 1 && _ctx.calendarRangeLastActive[0] ? (_openBlock(), _createBlock(_component_w_tag, {
    key: 1,
    "text-tag": _ctx.$t('admin.dashboard.users.table.lastActive') + ': ' + _ctx.selectedLastActive,
    round: "",
    closable: true,
    onRemoveTag: _ctx.clearFilterByLastActive
  }, null, 8, ["text-tag", "onRemoveTag"])) : _createCommentVNode("", true), _ctx.calendarRangeCreated && _ctx.calendarRangeCreated.length >= 1 && _ctx.calendarRangeCreated[0] ? (_openBlock(), _createBlock(_component_w_tag, {
    key: 2,
    "text-tag": _ctx.$t('admin.dashboard.users.table.createdAt') + ': ' + _ctx.selectedCreated,
    round: "",
    closable: true,
    onRemoveTag: _ctx.clearFilterByCreated
  }, null, 8, ["text-tag", "onRemoveTag"])) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "labelClearFilters",
    onClick: _cache[2] || (_cache[2] =
    //@ts-ignore
    (...args) => _ctx.clearAllFilters && _ctx.clearAllFilters(...args))
  }, _toDisplayString(_ctx.$t('admin.dashboard.users.clearFilters')), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_18, [_createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(
    // noinspection TypeScriptValidateTypes: We can totally add parameters to the $t method, for parameterized translations (and it works)
    _ctx.$t('admin.dashboard.users.total', {
      count: _ctx.totalUsers,
      total: _ctx.totalUsers
    })), 1)]),
    _: 1
  })]), _withDirectives(_createVNode(_component_el_empty, {
    class: "emptyPanel",
    description: _ctx.$t('admin.dashboard.users.noResult')
  }, null, 8, ["description"]), [[_vShow, _ctx.infiniteLoadingEnd && _ctx.isEmptyResult && _ctx.emptyState]]), _createElementVNode("div", _hoisted_19, [_ctx.listUsers.length > 0 ? (_openBlock(), _createBlock(_component_el_table, {
    key: 0,
    class: "tableCustom",
    "row-class-name": "userManagementClickableRow",
    ref: "tableRef",
    data: _ctx.listUsers,
    onSelectionChange: _ctx.handleUsersSelectionChange,
    onRowClick: _ctx.selectUser
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      type: "selection",
      width: "55"
    }), _createVNode(_component_el_table_column, null, {
      header: _withCtx(() => [_createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('admin.dashboard.users.search.title.name')), 1)]),
      default: _withCtx(user => [_createVNode(_component_user_cell, {
        user: user.row,
        "search-term": _ctx.filterByName,
        "second-line-content": user.row.email,
        class: "userCell"
      }, null, 8, ["user", "search-term", "second-line-content"])]),
      _: 1
    }), _createVNode(_component_el_table_column, null, {
      header: _withCtx(() => [_createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('admin.dashboard.users.search.title.group')), 1)]),
      default: _withCtx(user => [!user.row.groups || user.row.groups.length === 0 || user.row.groups.length === 1 && user.row.groups[0].system ? (_openBlock(), _createElementBlock("div", _hoisted_22, " - ")) : (_openBlock(), _createElementBlock("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.row.groups.filter(g => !g.system).slice(0, 2), group => {
        return _openBlock(), _createBlock(_component_w_tag, {
          class: "tableChip",
          ellipsis: true,
          "text-tag": group.name,
          key: group.order,
          round: "",
          closable: false
        }, null, 8, ["text-tag"]);
      }), 128)), user.row.groups.filter(g => !g.system).length > 2 ? (_openBlock(), _createBlock(_component_w_tag, {
        key: 0,
        class: "tableChip",
        ellipsis: true,
        "text-tag": '+' + (user.row.groups.filter(g => !g.system).length - 2),
        round: "",
        closable: false
      }, null, 8, ["text-tag"])) : _createCommentVNode("", true)]))]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      width: "120"
    }, {
      header: _withCtx(() => [_createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('admin.dashboard.users.table.createdAt')), 1)]),
      default: _withCtx(user => [_createElementVNode("div", _hoisted_25, _toDisplayString(user.row.createdAt ? _ctx.$d(new Date(user.row.createdAt)) : '-'), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      width: "120"
    }, {
      header: _withCtx(() => [_createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('admin.dashboard.users.table.lastActive')), 1)]),
      default: _withCtx(user => [_createElementVNode("div", _hoisted_27, _toDisplayString(user.row.lastActiveDate ? _ctx.$d(new Date(user.row.lastActiveDate)) : '-'), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      width: "220"
    }, {
      header: _withCtx(() => [_createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('admin.dashboard.users.search.title.role')), 1)]),
      default: _withCtx(user => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRolesForUser(user.row).slice(0, 2), role => {
        return _openBlock(), _createBlock(_component_w_tag, {
          class: "tableChip",
          ellipsis: true,
          "text-tag": role.name,
          key: role.id,
          round: "",
          closable: false
        }, null, 8, ["text-tag"]);
      }), 128)), _ctx.getRolesForUser(user.row).length > 2 ? (_openBlock(), _createBlock(_component_w_tag, {
        key: 0,
        class: "tableChip",
        ellipsis: true,
        "text-tag": '+' + (_ctx.getRolesForUser(user.row).length - 2),
        round: "",
        closable: false
      }, null, 8, ["text-tag"])) : _createCommentVNode("", true), _ctx.getRolesForUser(user.row).length === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_29, "-")) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      width: "50"
    }, {
      default: _withCtx(user => [_createElementVNode("div", {
        class: "black default",
        onClick: $event => _ctx.selectUser(user.row)
      }, [_createVNode(_component_w_tool_tip, {
        text: _ctx.$t('admin.dashboard.users.table.infoTooltip')
      }, {
        default: _withCtx(() => [_createVNode(_component_icon, {
          class: "clickableIcon",
          icon: "pencil-outline"
        })]),
        _: 1
      }, 8, ["text"])], 8, _hoisted_30)]),
      _: 1
    }), _ctx.busyInfiniteLoading ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_loader)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["data", "onSelectionChange", "onRowClick"])) : _createCommentVNode("", true)]), _withDirectives((_openBlock(), _createBlock(_component_side_panel, {
    visible: _ctx.sidePanelVisible,
    class: "sidePanelContainer sidepanel-click-filter",
    "close-button-visible": true,
    "wide-side-panel": true,
    onClose: _ctx.closeSidePanel
  }, {
    default: _withCtx(() => [_ctx.selectedUser !== null ? (_openBlock(), _createBlock(_component_user_details, {
      key: 0,
      onReinitSearch: _ctx.reinitSearch,
      user: _ctx.selectedUser,
      "workflow-enabled": _ctx.workflowEnabled,
      aiPerUser: _ctx.aiPerUser,
      "user-password-is-editable": _ctx.userPasswordIsEditable,
      "user-password-min-chars": _ctx.userPasswordMinChars,
      "user-password-max-chars": _ctx.userPasswordMaxChars,
      "ai-license-available": _ctx.aiLicenseAvailable,
      "class-click-filter": "sidepanel-click-filter"
    }, null, 8, ["onReinitSearch", "user", "workflow-enabled", "aiPerUser", "user-password-is-editable", "user-password-min-chars", "user-password-max-chars", "ai-license-available"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["visible", "onClose"])), [[_directive_click_outside, _ctx.closeSidePanel]]), this.isLoaded ? (_openBlock(), _createBlock(_component_infinite_loading, {
    key: 1,
    identifier: _ctx.gridID,
    distance: 200,
    onInfinite: _ctx.debounceInfinite
  }, {
    "no-more": _withCtx(() => [...(_cache[10] || (_cache[10] = [_createElementVNode("div", null, null, -1)]))]),
    "no-results": _withCtx(() => [...(_cache[11] || (_cache[11] = [_createElementVNode("div", null, null, -1)]))]),
    spinner: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createVNode(_component_loader)])]),
    _: 1
  }, 8, ["identifier", "onInfinite"])) : _createCommentVNode("", true), _ctx.multiselectUsers.length > 0 ? (_openBlock(), _createBlock(_component_el_affix, {
    key: 2,
    position: "bottom",
    target: "#TableUsers",
    offset: 0
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createTextVNode(_toDisplayString(
    // noinspection TypeScriptValidateTypes: We can totally add parameters to the $t method, for parameterized translations (and it works)
    _ctx.$t('admin.dashboard.users.usersSelected', {
      count: _ctx.multiselectUsers.length
    })) + " ", 1), _createVNode(_component_w_tool_tip, {
      text: _ctx.$t('admin.dashboard.users.multiselect.deactivate')
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        class: "clickableIcon",
        icon: "delete-outline",
        onClick: _cache[3] || (_cache[3] = $event => _ctx.deactivateUsersPopup = true)
      })]),
      _: 1
    }, 8, ["text"]), _createVNode(_component_w_tool_tip, {
      text: _ctx.$t('admin.dashboard.users.multiselect.edit')
    }, {
      default: _withCtx(() => [_createVNode(_component_icon, {
        class: "clickableIcon",
        icon: "pencil-outline",
        onClick: _cache[4] || (_cache[4] = $event => _ctx.editInfosPopup = true)
      })]),
      _: 1
    }, 8, ["text"])]), _createVNode(_component_standard_button, {
      outlined: true,
      label: _ctx.$t('admin.dashboard.users.sidebar.deactivation.cancel'),
      onClick: _ctx.deselectAllUser
    }, null, 8, ["label", "onClick"])])]),
    _: 1
  })) : _createCommentVNode("", true), _createVNode(_component_w_dialog, {
    visible: _ctx.deactivateUsersPopup,
    onOnDialogClose: _cache[6] || (_cache[6] = $event => _ctx.deactivateUsersPopup = false)
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_37, [_createVNode(_component_standard_button, {
      outlined: true,
      label: _ctx.$t('admin.dashboard.users.sidebar.deactivation.cancel'),
      onClick: _cache[5] || (_cache[5] = $event => _ctx.deactivateUsersPopup = false)
    }, null, 8, ["label"]), _createVNode(_component_standard_button, {
      label: _ctx.$t('admin.dashboard.users.sidebar.deactivation.ok'),
      onClick: _ctx.deactivateListUsers
    }, null, 8, ["label", "onClick"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_35, [_createVNode(_component_icon, {
      class: "iconPopup",
      icon: "information-outline",
      size: "large"
    }), _createElementVNode("div", _hoisted_36, _toDisplayString(
    // noinspection TypeScriptValidateTypes: We can totally add parameters to the $t method, for parameterized translations (and it works)
    _ctx.$t('admin.dashboard.users.sidebar.deactivation.message', 2)), 1)])]),
    _: 1
  }, 8, ["visible"]), _createVNode(_component_w_dialog, {
    visible: _ctx.editInfosPopup,
    onOnDialogClose: _ctx.closeBatchEdit,
    title: _ctx.$t('admin.dashboard.users.batchEdit', {
      count: _ctx.multiselectUsers.length
    })
  }, {
    default: _withCtx(() => [_createVNode(_component_el_scrollbar, null, {
      default: _withCtx(() => [_ctx.editInfosPopup ? (_openBlock(), _createBlock(_component_batch_update_user, {
        key: 0,
        "users-to-update": _ctx.multiselectUsers,
        "workflow-enabled": _ctx.workflowEnabled,
        onBatchUpdateSuccess: _ctx.batchEditUsers,
        onBatchUpdateCancel: _ctx.closeBatchEdit
      }, null, 8, ["users-to-update", "workflow-enabled", "onBatchUpdateSuccess", "onBatchUpdateCancel"])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }, 8, ["visible", "onOnDialogClose", "title"])], 2);
}